
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 280 500"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"clip-path"}},[_c('path',{attrs:{"fill":"none","d":"M0 0h280v500H0z"}})])]),_c('g',{attrs:{"clip-path":"url(#clip-path)","id":"subCard4","data-name":"Vrstva 1"}},[_c('path',{attrs:{"fill":"#00213d","d":"M0 0h280v500H0z"}}),_c('path',{attrs:{"id":"transformEl2","d":"M3.61 207.34a285.22 285.22 0 0171.2 78.18c31.29 51 37.85 98.22 40.72 120.66A328.92 328.92 0 01114 500H0V204.34c.42.31.84.65 1.27 1 .84.66 1.61 1.34 2.34 2z","fill":"#0092ff"}}),_c('ellipse',{attrs:{"id":"transformEl","cx":"226.67","cy":"111.15","rx":"145.97","ry":"176.23","fill":"#00317f"}})])])
          )
        }
      }
    